module.exports = __webpack_public_path__ + "media/src/images/icon/check-021870a9e481bebacc5d066cc571bdea.png";